<script setup lang="ts">
import { ref, watch } from 'vue'
import FadeTransition from '../transitions/FadeTransition.vue'

interface Props {
  loading: boolean
}

defineOptions({ inheritAttrs: false })
const props = defineProps<Props>()

const visible = ref<boolean>(false)
const timerId = ref<NodeJS.Timeout>()

watch(
  () => props.loading,
  (loading) => {
    clearTimeout(timerId.value)

    if (loading) {
      visible.value = true
    } else {
      timerId.value = setTimeout(() => {
        visible.value = false
      }, 700)
    }
  },
  { immediate: true },
)
</script>

<template>
  <FadeTransition>
    <div v-show="visible" class="w-full h-0.5 overflow-hidden" v-bind="$attrs">
      <div
        class="h-full w-1/2 bg-linear-to-r from-primary/60 via-primary to-primary/30 animate-indeterminate transform-gpu"
      ></div>
    </div>
  </FadeTransition>
</template>
